// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v3.50.1-2-gc9ee256",
    "hash": "gc9ee256",
    "distance": 2,
    "tag": "v3.50.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v3.50.1",
        "major": 3,
        "minor": 50,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "3.50.1"
    },
    "suffix": "2-gc9ee256",
    "semverString": "3.50.1+2.gc9ee256",
    "version": "3.50.1"
};
/* tslint:enable */
